import { IIncidents, IncidentStatusDuration, TransitionMatrixPerDateEntry } from 'src/app/models/incident';
import {
  IRiskGraph,
  IRiskQuestions,
  IRiskSingleGraph,
} from 'src/app/models/riskProfile';
import { ComplaintsTickets, VisitorTickets } from 'src/app/models/tickets';
import { Visitor } from 'src/app/models/visitor';

export interface IAnalyticsState {
  categorizedRiskScore: any;
  flows: {
    isVisitorAnalytics: boolean;
    isIncidentAnalytics: boolean;
  };
  status: {
    isError: boolean;
    isFetchingApiRequest: boolean;
    isVisitorAnalyticsDataLoaded: boolean;
    isRiskAnalyticsDataLoaded: boolean;
    isIncidentAnalyticsDataLoaded: boolean;
    isComplaintsDataLoaded: boolean;
    isClaimsDataLoaded: boolean;
    isRequestsDataLoaded: boolean;
  };
  Error: {
    errorMessage: string;
    errorStatus: string;
  };
  visitorDetails: {
    visitorList: Visitor[];
    totalVerified: number;
    totalUnverified: number;
    totalVisitor: number;
  };
  incidentDetails: {
    incidentList: IIncidents[];
    totalIncidents: number;
    totalOpen: number;
    totalClosed: number;
    totalSnoozed: number;
    totalUnassigned: number;
  };
  visitorTickets: VisitorTickets[];
  incidentTickets: VisitorTickets[];
  complaintsTickets: ComplaintsTickets[];
  claimsTickets: ComplaintsTickets[];
  requestsTickets: ComplaintsTickets[];
  riskQuestions: IRiskQuestions[];
  riskAnalyticsGraph: IRiskGraph[];
  riskAnalyticsPreviousMonthGraph: IRiskGraph[];
  riskSingleAnalyticsGraph: IRiskSingleGraph[];
  averageCloseTime: any;
  criticalIncidentsCounts: any;
  criticalIncidentsData: any;
  criticalIncidentsCountNumber: any;
  currentMonthRiskScore: number;
  previousMonthRiskScore: number;
  criticalRiskHour: number;
  hotCheckInSlot: number;
  monthlyVisitorBarGraph: any;
  monthlyVisitorInOutGraph: any;
  monthlyVisitorCategory: any;
  riskHeatMapData: any;
  riskAnalyticsStatusGraph: any;
  uniqueVisitors: number;
  currentDayVisitors: number;
  currentMonthClaimTotal: number;
  previousMonthClaimTotal: number;
  currentMonthClaimAmount: number;
  previousMonthClaimAmount: number;
  categoryRiskTrends: any;
  processedIncidents: any;
  categorizedIncidents: any;
  overallRiskScore: number;
  overallRiskTrend: string;
  overallRiskChangePercentage: number;
  totalCount: any;
  overallRiskScoresByDateRange: any;
  incidentAnalytics: {
    totalIncidents: number;
    openToCloseTimeRatio: number;
    // averageTimePerStatus: IncidentStatusDuration[];
    averageTimePerStatus: { [date: string]: { [status: string]: number } };
    criticalToMedium: number;
    criticalToLow: number;
    breakdownGraphData: any;
    incidentGraphCounts: any;
    // incidentCountByCategory: {
    //   [category: string]: number;
    // };
    // incidentStatusCounts: {
    //   [status: string]: number;
    // };
    incidentCountByCategory: { [date: string]: { [category: string]: number } };
    incidentStatusCounts: { [date: string]: { [status: string]: number } };
    transitionMatrix: { [key: string]: { item1: number; item2: number } }
    resolutionRatePerDay: { [date: string]: number; }
    transitionMatrixPerDate: TransitionMatrixPerDateEntry[];
  }
  visitorAnalytics: {
    getCheckInToCheckOutRatio: { [date: string]: number };
    getRepeatingVisitors: { [date: string]: number };
    getTotalVisitors: { [date: string]: number };
    getUniqueVisitors: { [date: string]: number };
    visitorTypeTotals: { [date: string]: { [category: string]: number } };
  }
  // assetAnalytics: {
  //   getBookingByDates: {
  //     [date: string]: number;
  //   };
  //   getBookingByAssets: {
  //     [date: string]: {
  //       [assetId: string]: number;
  //     };
  //   };
  // }
  bookingAnalytics: {
    getBookingByDates: { [date: string]: number };
    getBookingByAssets: { [date: string]: { [status: string]: number } };
  }
  eventAnalytics: {
    getTotalEvent: { [date: string]: { [status: string]: number } };
    getVisitorAttentedToTotalRatio: { [date: string]: { [status: string]: number } }; 
    getVisitorPerEvent: { [date: string]: { [status: string]: number } };
  }
  animalAnalytics: {
    getFoodCosumption: { [date: string]: { [status: string]: number } };
    getCostOfMaintenance: { [date: string]: { [status: string]: number } }; 
    getHealthStat: { [date: string]: { [status: string]: number } };
  }
  assetAnalytics: {
    getPowerConsumption: { [date: string]: { [status: string]: number } };
    getPropertyPowerConsumption: { [date: string]: { [status: string]: number } };
    getPropertyTemperature: { [date: string]: { [status: string]: number } };
  }
}
export const initIAnalyticsState: IAnalyticsState = {
  flows: {
    isVisitorAnalytics: false,
    isIncidentAnalytics: false,
  },
  status: {
    isError: false,
    isFetchingApiRequest: false,
    isRiskAnalyticsDataLoaded: false,
    isVisitorAnalyticsDataLoaded: false,
    isIncidentAnalyticsDataLoaded: false,
    isComplaintsDataLoaded: false,
    isClaimsDataLoaded: false,
    isRequestsDataLoaded: false,
  },
  Error: {
    errorMessage: '',
    errorStatus: '',
  },
  visitorDetails: {
    visitorList: [],
    totalVerified: null,
    totalUnverified: null,
    totalVisitor: null,
  },
  incidentDetails: {
    incidentList: [],
    totalIncidents: null,
    totalOpen: null,
    totalClosed: null,
    totalSnoozed: null,
    totalUnassigned: null,
  },
  visitorTickets: [],
  incidentTickets: [],
  complaintsTickets: [],
  claimsTickets: [],
  requestsTickets: [],
  riskQuestions: [],
  riskAnalyticsGraph: [],
  riskSingleAnalyticsGraph: [],
  riskAnalyticsPreviousMonthGraph: [],
  averageCloseTime: null,
  criticalIncidentsCounts: null,
  criticalIncidentsData: null,
  criticalIncidentsCountNumber: null,
  currentMonthRiskScore: null,
  previousMonthRiskScore: null,
  criticalRiskHour: null,
  hotCheckInSlot: null,
  monthlyVisitorBarGraph: null,
  monthlyVisitorCategory: null,
  monthlyVisitorInOutGraph: null,
  uniqueVisitors: null,
  currentDayVisitors: null,
  riskHeatMapData: null,
  riskAnalyticsStatusGraph: null,
  currentMonthClaimTotal: null,
  previousMonthClaimTotal: null,
  currentMonthClaimAmount: null,
  previousMonthClaimAmount: null,
  categoryRiskTrends: null,
  overallRiskScore: null,
  overallRiskTrend: null,
  overallRiskChangePercentage: null,
  categorizedIncidents: null,
  processedIncidents: null,
  totalCount: null,
  overallRiskScoresByDateRange: null,
  incidentAnalytics: {
    openToCloseTimeRatio: 0,
    averageTimePerStatus: {},
    criticalToMedium: 0,
    criticalToLow: 0,
    incidentCountByCategory: {},
    incidentStatusCounts: {},
    totalIncidents: 0,
    transitionMatrix: {},
    resolutionRatePerDay: {},
    breakdownGraphData: {},
    incidentGraphCounts: {},
    transitionMatrixPerDate: []
  },
  visitorAnalytics: undefined,
  // assetAnalytics: {
  //   getBookingByDates: {},
  //   getBookingByAssets: {}
  // },
  categorizedRiskScore: null,
  bookingAnalytics: {
    getBookingByDates: {},
    getBookingByAssets: {}
  },
  eventAnalytics: {
    getTotalEvent: {},
    getVisitorPerEvent: {},
    getVisitorAttentedToTotalRatio: {}
  },
  animalAnalytics: {
    getFoodCosumption: {},
    getCostOfMaintenance: {},
    getHealthStat: {}
  },
  assetAnalytics: {
    getPowerConsumption: {},
    getPropertyPowerConsumption: {},
    getPropertyTemperature: {}
  }
};
